import React from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowLeft } from "react-icons/hi";
import "../../assets/style/FormHeading.css";

const FormHeading = ({ heading, path, isHideBtn = false, isPassState = false, state }) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        if (isPassState) {
            navigate(path, { state: { fileData: state } });
        } else {
            navigate(path);
        }
    };

    return (
        <div className="form-heading-wrapper usa-prose">
            <div className="form-heading-content">
                {!isHideBtn && (
                    <div className="back-button" onClick={handleBackClick}>
                        <HiArrowNarrowLeft className="back-icon" />
                    </div>
                )}
                <h3 className="form-heading-title">{heading}</h3>
            </div>
        </div>
    );
};

export default FormHeading;
